{
  "businessUnit": {
    "list": {
      "deviceCount": "{count} devices|{count} device|{count} devices"
    },
    "settings": {
      "description": {
        "information": "Information",
        "title": "Information"
      },
      "button": "Settings",
      "users": {
        "title": "Users"
      },
      "firmwares": {
        "title": "Firmware"
      },
      "logs": {
        "title": "Logs"
      }
    },
    "name": "Business Unit name",
    "addOrganization": {
      "button": "Add an organization"
    },
    "leave": {
      "title": "Edit the Business Unit"
    }
  },
  "entityLocation": {
    "location": "Location",
    "country": "Country",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "timezone": "Timezone",
    "countryError": "Country is required.",
    "latitudeError": "Latitude must be between -90 and 90.",
    "longitudeError": "Longitude must be between -180 and 180.",
    "timezoneError": "Timezone is required.",
    "countryPlaceholder": "Choose the country",
    "countrySearchPlaceholder": "Search by name of country",
    "countryPopular": "Popular"
  },
  "superAdministration": {
    "settings": {
      "title": "Modify {name}",
      "information": {
        "title": "Information",
        "subtitle": "Organization name",
        "nameLabel": "Name"
      },
      "button": "Settings",
      "users": {
        "title": "Users"
      },
      "pki": {
        "title": "PKI",
        "newConnection": "New connection"
      },
      "logs": {
        "title": "Logs"
      }
    }
  },
  "organization": {
    "create": {
      "title": "Organization creation",
      "saveButton": "Create the organization"
    },
    "information": {
      "title": "Organization information"
    },
    "name": "Organization name",
    "type": {
      "label": "Type",
      "placeholder": "Select type",
      "operator": "Operator organization",
      "administration": "Administration organization"
    },
    "nameRequiredError": "The name is required.",
    "typeError": "Type is required.",
    "nameLengthError": "Length between {min} and {max} characters.",
    "settings": {
      "information": {
        "title": "Information"
      },
      "description": {
        "title": "Description"
      },
      "users": {
        "title": "Users"
      },
      "operationButton": "Operation",
      "logs": {
        "title": "Logs"
      },
      "license": {
        "title": "License"
      },
      "certificate": {
        "title": "Certificate"
      }
    },
    "leave": {
      "title": "Edit the organization",
      "message": "All unsaved data will be lost."
    }
  },
  "entityAdmin": {
    "lastname": "Administrator last name",
    "title": "Administrator information",
    "firstname": "Administrator first name",
    "login": "Administrator login",
    "email": "Administrator email",
    "language": "Language"
  },
  "country": {
    "GRC": "Greece",
    "MOZ": "Mozambique",
    "FRA": "France",
    "MUS": "Mauritius",
    "BWA": "Botswana",
    "CAF": "Central African Republic",
    "FIN": "Finland",
    "KAZ": "Kazakhstan",
    "MHL": "Marshall Islands",
    "MNE": "Montenegro",
    "MYS": "Malaysia",
    "NPL": "Nepal",
    "NZL": "New Zealand",
    "PER": "Peru",
    "USA": "United States of America",
    "YEM": "Yemen",
    "CMR": "Cameroon",
    "CUB": "Cuba",
    "DOM": "Dominican Republic",
    "ITA": "Italy",
    "LBR": "Liberia",
    "SWE": "Sweden",
    "TUN": "Tunisia",
    "WSM": "Samoa",
    "CUW": "Curaçao",
    "DNK": "Denmark",
    "IDN": "Indonesia",
    "SGP": "Singapore",
    "SLV": "El Salvador",
    "UGA": "Uganda",
    "URY": "Uruguay",
    "VEN": "Venezuela (Bolivarian Republic of)",
    "DEU": "Germany",
    "GUM": "Guam",
    "MKD": "Macedonia (the former Yugoslav Republic of)",
    "MWI": "Malawi",
    "PAK": "Pakistan",
    "PRT": "Portugal",
    "BEL": "Belgium",
    "BOL": "Bolivia (Plurinational State of)",
    "COM": "Comoros",
    "CHE": "Switzerland",
    "GHA": "Ghana",
    "IRN": "Iran (Islamic Republic of)",
    "IRQ": "Iraq",
    "JAM": "Jamaica",
    "NLD": "Netherlands",
    "POL": "Poland",
    "VAT": "Vatican City",
    "AFG": "Afghanistan",
    "DZA": "Algeria",
    "HKG": "Hong Kong",
    "LAO": "Lao Peoples Democratic Republic",
    "NRU": "Nauru",
    "TKM": "Turkmenistan",
    "ZMB": "Zambia",
    "AUS": "Australia",
    "BHS": "Bahamas",
    "BIH": "Bosnia and Herzegovina",
    "CZE": "Czech Republic",
    "KOR": "Korea (Republic of)",
    "PHL": "Philippines",
    "VCT": "Saint Vincent and the Grenadines",
    "ARM": "Armenia",
    "AZE": "Azerbaijan",
    "BDI": "Burundi",
    "BGD": "Bangladesh",
    "ECU": "Ecuador",
    "ETH": "Ethiopia",
    "GAB": "Gabon",
    "GMB": "Gambia",
    "HTI": "Haiti",
    "KIR": "Kiribati",
    "MAC": "Macao",
    "MMR": "Myanmar",
    "PRI": "Puerto Rico",
    "QAT": "Qatar",
    "SVK": "Slovakia",
    "TGO": "Togo",
    "UKR": "Ukraine",
    "CAN": "Canada",
    "MLI": "Mali",
    "MNP": "Northern Mariana Islands",
    "SDN": "Sudan",
    "BRB": "Barbados",
    "FJI": "Fiji",
    "KGZ": "Kyrgyzstan",
    "MAF": "Saint Martin (French part)",
    "MRT": "Mauritania",
    "ZWE": "Zimbabwe",
    "CA-QC": "Quebec",
    "CHL": "Chile",
    "HRV": "Croatia",
    "SAU": "Saudi Arabia",
    "ASM": "American Samoa",
    "BMU": "Bermuda",
    "COD": "Congo (Democratic Republic of the)",
    "CRI": "Costa Rica",
    "GIN": "Guinea",
    "IMN": "Isle of Man",
    "JPN": "Japan",
    "SLB": "Solomon Islands",
    "SMR": "San Marino",
    "SUR": "Suriname",
    "TCA": "Turks and Caicos Islands",
    "ATG": "Antigua and Barbuda",
    "COG": "Congo",
    "HND": "Honduras",
    "KNA": "Saint Kitts and Nevis",
    "ROU": "Romania",
    "STP": "Sao Tome and Principe",
    "ZAF": "South Africa",
    "BGR": "Bulgaria",
    "BRN": "Brunei Darussalam",
    "CYP": "Cyprus",
    "FSM": "Micronesia (Federated States of)",
    "MAR": "Morocco",
    "MDA": "Moldova (Republic of)",
    "MDG": "Madagascar",
    "MNG": "Mongolia",
    "SLE": "Sierra Leone",
    "TLS": "Timor-Leste",
    "VNM": "Viet Nam",
    "AGO": "Angola",
    "BLZ": "Belize",
    "HUN": "Hungary",
    "IRL": "Ireland",
    "KWT": "Kuwait",
    "MDV": "Maldives",
    "NER": "Niger",
    "NIC": "Nicaragua",
    "PSE": "Palestine",
    "TWN": "Taiwan",
    "ARG": "Argentina",
    "COL": "Colombia",
    "JOR": "Jordan",
    "NAM": "Namibia",
    "SRB": "Serbia",
    "TJK": "Tajikistan",
    "CPV": "Cabo Verde",
    "GEO": "Georgia",
    "KOS": "Republic of Kosovo",
    "LUX": "Luxembourg",
    "OMN": "Oman",
    "RUS": "Russian Federation",
    "SOM": "Somalia",
    "SYC": "Seychelles",
    "TCD": "Chad",
    "TUV": "Tuvalu",
    "AND": "Andorra",
    "BHR": "Bahrain",
    "BRA": "Brazil",
    "DJI": "Djibouti",
    "DMA": "Dominica",
    "EST": "Estonia",
    "ISR": "Israel",
    "MCO": "Monaco",
    "MLT": "Malta",
    "SEN": "Senegal",
    "SXM": "Sint Maarten (Dutch part)",
    "VUT": "Vanuatu",
    "ABW": "Aruba",
    "BEN": "Benin",
    "BLR": "Belarus",
    "CYM": "Cayman Islands",
    "GIB": "Gibraltar",
    "GNB": "Guinea-Bissau",
    "GRD": "Grenada",
    "IND": "India",
    "LBY": "Libya",
    "LCA": "Saint Lucia",
    "LVA": "Latvia",
    "PRK": "Korea (Democratic Peoples Republic of)",
    "SSD": "South Sudan",
    "TTO": "Trinidad and Tobago",
    "ALB": "Albania",
    "BTN": "Bhutan",
    "CIV": "Côte d'Ivoire",
    "LKA": "Sri Lanka",
    "PAN": "Panama",
    "SYR": "Syrian Arab Republic",
    "UZB": "Uzbekistan",
    "AUT": "Austria",
    "EGY": "Egypt",
    "ERI": "Eritrea",
    "FRO": "Faroe Islands",
    "GNQ": "Equatorial Guinea",
    "GRL": "Greenland",
    "GUY": "Guyana",
    "LTU": "Lithuania",
    "MEX": "Mexico",
    "NOR": "Norway",
    "RWA": "Rwanda",
    "SWZ": "Swaziland",
    "THA": "Thailand",
    "ARE": "United Arab Emirates",
    "ESP": "Spain",
    "GBR": "United Kingdom of Great Britain and Northern Ireland",
    "ISL": "Iceland",
    "KEN": "Kenya",
    "LSO": "Lesotho",
    "NGA": "Nigeria",
    "PLW": "Palau",
    "PNG": "Papua New Guinea",
    "BFA": "Burkina Faso",
    "CHN": "China",
    "KHM": "Cambodia",
    "LBN": "Lebanon",
    "LIE": "Liechtenstein",
    "PRY": "Paraguay",
    "SVN": "Slovenia",
    "TON": "Tonga",
    "TUR": "Turkey",
    "TZA": "Tanzania",
    "VGB": "Virgin Islands (British)",
    "GTM": "Guatemala"
  },
  "relation": {
    "since": "Since: {date}",
    "delete": {
      "confirm": {
        "title": "Delete the relationship",
        "description": "Are you sure you want to delete the relationship with {name}?"
      }
    }
  },
  "relations": {
    "affiliations": {
      "title": "Affiliation",
      "add": {
        "button": "Add an affiliation"
      },
      "parentEntity": {
        "title": "Parent entity"
      },
      "childrenEntities": {
        "title": "Affiliated entities"
      }
    },
    "delegations": {
      "title": "Delegation",
      "add": {
        "button": "Add a delegation"
      }
    },
    "title": "Relationships",
    "add": {
      "createLink": "Create a link with an existing organization",
      "createOrganization": "Create a new organization"
    },
    "uploadIdCard": {
      "title": "Upload the organization's ID card",
      "validation": {
        "fileMandatory": "File must be a .JSON",
        "fileEmpty": "The file must not be empty",
        "fileSize": "The file must be less than 750MB in size"
      }
    },
    "contact": {
      "administrator": "Administrator:",
      "noContact": "No contact identified",
      "referentUser": {
        "title": "Organization contact",
        "description": "Designated contact for operational, support, or commercial requests related to this organization.",
        "selectUser": "Select a user",
        "modified": "Change the contact"
      }
    }
  }
}
